import { useLang } from "../context/LangContext";
import { WHATSAPP_URL, TELEGRAM_URL } from "../constants";
import { WhatsAppIcon, TelegramIcon } from "./icons";

export const MobileStickyBar = () => {
  const { t } = useLang();

  return (
    <div
      data-testid="mobile-sticky-bar"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-navy-950/85 px-3 py-2.5 backdrop-blur-xl md:hidden"
      style={{ paddingBottom: "max(0.625rem, env(safe-area-inset-bottom))" }}
    >
      <div className="flex gap-2.5">
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-sticky-whatsapp"
          className="flex flex-1 items-center justify-center gap-2 rounded-full bg-gradient-to-r from-green-600 to-green-500 py-3 text-sm font-bold text-white shadow-[0_0_20px_rgba(34,197,94,0.35)]"
        >
          <WhatsAppIcon className="h-5 w-5" />
          WhatsApp
        </a>
        <a
          href={TELEGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-sticky-telegram"
          className="flex flex-1 items-center justify-center gap-2 rounded-full bg-gradient-to-r from-sky-600 to-blue-500 py-3 text-sm font-bold text-white shadow-[0_0_20px_rgba(56,160,240,0.35)]"
        >
          <TelegramIcon className="h-5 w-5" />
          Telegram
        </a>
      </div>
    </div>
  );
};
